module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"text":"Klikk \u0027memo\u0027 nederst i artikkelen for å lære det viktigste i steget med morsomme husketeknikker."},"en":{"text":"Klikk \u0027memo\u0027 nederst i artikkelen for å lære det viktigste i steget med morsomme husketeknikker."}}')
  delete Component.options._Ctor
}
